export const buildAnimationConfig = (animated = true) => ({
  animation: animated,
  animationDuration: animated ? 600 : 0,
});
